<template>
    <card :noFooterLine="false" class="notice-card" :class="{ 'skeleton' : isSkeleton }" @click.native="cardClick">

        <div slot="image" v-if="image_url" class="notice-card-image" :style="`background-image:url(${image_url})`"></div>

        <div slot="header" v-if="!isSkeleton">
            <h6 class="card-category" v-if="batches.length > 0">{{ batches.join(', ') }}</h6>
            <pre class="card-title" v-html="notice"></pre>
            <a :href="link" target="_blank" rel="noopener noreferrer">{{ link }}</a>
        </div>

        <skeleton-loading v-if="isSkeleton">
            <row :gutter="{top: '10px', bottom: '10px'}">
                <column :span="1" :gutter="10" class="col-12">
                    <square-skeleton :boxProperties="{ bottom: '10px', height: '10px', width: '15%' }" backColor="#bdc3c7"></square-skeleton>
                    <square-skeleton :boxProperties="{ bottom: '5px', height: '10px', width: '100%' }" :count="2"></square-skeleton>
                </column>
            </row>
        </skeleton-loading>

        <div slot="footer" v-if="!isSkeleton && isNotification">
            <span class="card-category text-left">{{ date }}</span> <span class="card-category text-right"  v-if="topics && topics.length > 0">{{ topics.join(', ') }}</span>
        </div>
    </card>
</template>

<script>

import { Card } from 'src/components';
import {Tooltip} from 'element-ui';

export default {
    name: 'NoticeCard',
    components: {
        Card,
        [Tooltip.name]: Tooltip,
    },
    props: {
        notice: String,
        batches: Array,
        isNotification: Boolean,
        topics: Array,
        sent_time: [String, Date],
        image_url:{
            type: String,
            default: null
        },
        link: String
    },
    computed: {
        date: function(){
            if(this.sent_time){
                let date = new Date(this.sent_time)
                return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            }
            else{
                return ''
            }
        },
        isSkeleton: function(){
            return (this.notice == undefined || this.notice == null) && (this.title == undefined || this.title == null) ? true : false
        }
    },
    methods: {
        cardClick(){
            this.$emit('card-click', this.news)
        }
    }
}
</script>

<style lang="scss">

.vue-skeleton-loading .skeleton-bac-animation{
    z-index: 1!important;
}

@keyframes backpos{ 0%{ background-position-x: -100px; } to { background-position-x: 100%; } }

.notice-card{
    
    hr {
        margin-top: 0;
        margin-bottom: 0;
    }

    &.skeleton{
        cursor: pointer;

        .card-image,
        .card-header,
        .card-footer,
        .news-card-body{
            display: none;
        }

        .card-body{
            width: 100%;
        }
    }  

    .card-image{
        height: 100px;

        .notice-card-image{
            height: 100px;
            background-size: cover;
        }
    }


    .card-footer .status-btns .btn{
        margin-right: 3px;
    }

    .card-header .card-title{
        margin-bottom: 0.5rem;
        margin-top: 5px;
        font-size: 1rem;
    }

    .category, .card-category{
        margin-bottom: 0.2em;
    }

    .card-body{
        padding: 5px 15px 15px 15px;
    }

    .description, 
    .card-description, 
    .footer-big p, 
    .footer .stats{
        color: #353a3e;
    }

    .card-footer{
        span{
            color: #555;
            display: inline-block;
            width: 50%;
        }
    }

} 
</style>
